import {
  getResolveObjectFromGridConfiguration,
  GridConfiguration,
  vsComponentName as recordGridViewComponentName,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../records/views/recordGridView";
import { StateParams, StateProvider, StateService } from "@uirouter/angularjs";
import { vsObjectName as mealLogName } from "./configs/mealLog";
import { vsComponentName as FormViewComponentName } from "../records/forms/formView";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../records/grids/columns/columnDefinitionService";
import { IRowCommandEventArgs } from "../records/grids/controller";
import { IQService } from "angular";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../records/server/serverUtility";
import { Record } from "../records/server/crud";
import { IQueryResponse, ServiceResponse } from "../records/server/query";

import { vsComponentName as entryDetailComponentName } from "./components/entryDetail";
import { resolveMealLogForm } from "./components/entryDetail/resolveMealLogForm";
import {
  SelectRecordModalService,
  vsServiceName as SelectRecordModalServiceName,
} from "../records/services/selectRecordModal";
import {
  UserProfile,
  vsName as UserProfileName,
} from "../application/UserProfile";

const baseState = "main.mealLog";

routeConfig.$inject = ["$stateProvider"];
export function routeConfig($stateProvider: StateProvider) {
  $stateProvider
    .state(baseState, {
      url: "mealLog",
      component: recordGridViewComponentName,
      resolve: {
        ...getResolveObjectFromGridConfiguration([
          RecordGridViewServiceName,
          (recordGridViewService: RecordGridViewService) =>
            recordGridViewService.getGridConfiguration(mealLogName),
        ]),
        columns: [
          "gridConfiguration",
          ColumnDefinitionServiceName,
          (
            gridConfiguration: GridConfiguration,
            columnDefinitionService: ColumnDefinitionService
          ) => [
            columnDefinitionService.getLinkColDef({
              headerName: "info",
              iconClass: "fa fa-info-circle text-primary",
              colId: "info",
              stateExpression: ".detail({ id: data.Id})",
            }),
            columnDefinitionService.getLinkColDef({
              headerName: "edit",
              iconClass: "fa fa-pencil text-primary",
              colId: "edit",
              stateExpression: ".detail.edit({ id: data.Id})",
              requiresPermission: "mealLogUpdate",
            }),
            columnDefinitionService.getNumberColDef({
              field: "Id",
              hide: true,
            }),
            ...(gridConfiguration.columns ?? []),
          ],
        ],
        onAddNew: [
          "$state",
          SelectRecordModalServiceName,
          RecordGridViewServiceName,
          (
            $state: StateService,
            selectRecordModalService: SelectRecordModalService,
            recordGridViewService: RecordGridViewService
          ) => [
            () => {
              const gridConfiguration =
                recordGridViewService.getGridConfiguration("machine")!;

              const modal = selectRecordModalService.openModal({
                gridConfiguration,
                onItemSelected: (item, modalInstance) => {
                  modalInstance.close(item);
                  modalInstance.result.then((item) =>
                    $state.go(".add", { machineId: item.MachineId })
                  );
                },
                title: "Machines",
              });

              return modal.result;
            },
          ],
        ],
      },
    })
    .state(`${baseState}.add`, {
      url: "/add/{machineId:int}",
      views: {
        "@^.^": {
          component: FormViewComponentName,
        },
      },
      resolve: resolveMealLogForm(
        "Create MEAL Log",
        [
          "$stateParams",
          UserProfileName,
          ($stateParams: StateParams, userProfile: UserProfile) => {
            return {
              MachineId: $stateParams.machineId,
              UserAuthId: userProfile.Id,
              UserAuth: userProfile
            };
          },
        ],
        baseState
      ),
    })

    .state(`${baseState}.detail.edit`, {
      url: "/edit",
      resolve: resolveMealLogForm(
        "Edit MEAL Log",
        ["mealLog", (mealLog: any) => mealLog],
        baseState
      ),
      views: {
        "@^.^.^": {
          component: FormViewComponentName,
        },
      },
    })
    .state(`${baseState}.detail`, {
      url: "/{id:int}",
      views: {
        "@^.^": {
          component: entryDetailComponentName,
        },
      },
      resolve: {
        info: [
          ServerUtilityName,
          "gridConfiguration",
          "mealLog",
          (
            serverUtility: ServerUtility,
            gridConfiguration: GridConfiguration,
            mealLog: any
          ) => {
            const url = gridConfiguration.gridDataSource?.url;
            if (!url) throw new Error("Couldn't determine Url");
            return serverUtility.querySingle<IQueryResponse<Record>>({
              url,
              query: { Id: mealLog.Id },
            });
          },
        ],
        mealLog: [
          ServerUtilityName,
          "$stateParams",
          (serverUtility: ServerUtility, $stateParams: StateParams) =>
            serverUtility
              .getById<ServiceResponse<Record>>({
                url: "/api/machines/mealLog",
                id: $stateParams.id,
              })
              .then((mealLogResponse) => {
                const value = <any>{ ...mealLogResponse.Result };
                const userAuth = value.UserAuth;

                value.UserAuth = {
                  ...userAuth,
                  DisplayName:
                    userAuth.DisplayName ??
                    `${userAuth.FirstName} ${userAuth.LastName}`,
                };
                return value;
              }),
        ],
        afterDelete: [
          "$state",
          ($state: StateService) => [() => $state.go(baseState)],
        ],
      },
    });
}
